import React, { FC, useEffect, useState } from 'react'
import { KTIcon } from '../../../../helpers'
import { useLayout } from '../../../../layout/core'
import moment from 'moment'

type FullTransactionType = {
    id: string
    sender: string
    recipient: string
    currency: string
    amount: number
    fees: number
    status: string
    timestamp: string
    note: string
    type: string
}

const DrawerTransactionHistory: FC = () => {
    const { transactionHistoryDetails } = useLayout()
    const [txnDetails, setTxnDetails] = useState<FullTransactionType | null>(null)

    useEffect(() => {
        if (transactionHistoryDetails) {
            setTxnDetails(transactionHistoryDetails)
        }
    }, [transactionHistoryDetails])

    return (
        <div
            id='transaction-history-drawer'
            className='bg-body'
            data-kt-drawer='true'
            data-kt-drawer-name='transaction-history'
            data-kt-drawer-activate='true'
            data-kt-drawer-overlay='true'
            data-kt-drawer-width="{default:'300px', 'lg': '600px'}"
            data-kt-drawer-direction='end'
            data-kt-drawer-toggle='#transaction-history-drawer-toggle'
            data-kt-drawer-close='#transaction-history-close'
        >
            <div className='card rounded-0 w-100'>
                {/* Header */}
                <div className='card-header'>
                    <h3 className='card-title fw-bolder text-dark'>Transaction Details</h3>
                    <div className='card-toolbar'>
                        <button
                            type='button'
                            className='btn btn-sm btn-icon btn-active-light-primary me-n5'
                            id='transaction-history-close'
                        >
                            <KTIcon iconName='cross' className='fs-1' />
                        </button>
                    </div>
                </div>

                {/* Body */}
                <div className='card-body bg-light'>
                    {!txnDetails ? (
                        <div className='text-center py-10'>
                            <div className='spinner-border text-primary' role='status'>
                                <span className='visually-hidden'>Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className='d-flex flex-column gap-5'>
                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Transaction ID:</span>
                                <span className='fw-semibold text-dark'>{txnDetails.id}</span>
                            </div>

                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Sender:</span>
                                <span className='fw-semibold text-dark'>{txnDetails.sender}</span>
                            </div>

                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Receiver:</span>
                                <span className='fw-semibold text-dark'>{txnDetails.recipient}</span>
                            </div>

                            {/* <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Currency Type:</span>
                                <span className='fw-semibold text-dark'>{txnDetails.currency}</span>
                            </div> */}

                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Amount:</span>
                                <span className='fw-semibold text-dark'>${txnDetails.amount}</span>
                            </div>


                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Transaction Fees:</span>
                                <span className='fw-semibold text-dark'>${txnDetails.fees || 0}</span>
                            </div>
                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Type:</span>
                                <span className='fw-semibold text-dark text-capitalize'>{txnDetails.type?.replace(/_/g, ' ')}</span>
                            </div>

                            {/* <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Method:</span>
                                <span className='fw-semibold text-dark'>{txnDetails.method}</span>
                            </div> */}

                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Status:</span>
                                <span
                                    className={`badge fw-semibold text-capitalize ${txnDetails.status == 'completed' || txnDetails.status == 'complete' || txnDetails.status == 'success'
                                        ? 'badge-light-success'
                                        : txnDetails.status === 'Pending'
                                            ? 'badge-light-warning'
                                            : 'badge-light-danger'
                                        }`}
                                >
                                    {txnDetails.status}
                                </span>
                            </div>

                            <div className='d-flex justify-content-between border-bottom pb-3'>
                                <span className='fw-bold text-gray-600'>Date:</span>
                                <span className='fw-semibold text-dark'>
                                    {moment(txnDetails.timestamp).format('DD MMM YYYY, hh:mm A')}
                                </span>
                            </div>

                            <div className='d-flex flex-column'>
                                <span className='fw-bold text-gray-600 mb-1'>Description:</span>
                                <span className='fw-semibold text-dark'>{txnDetails.note}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export { DrawerTransactionHistory }
